export function setRequestHeader(authClient, headerName, headerValue) {
    authClient.options.headers = authClient.options.headers || {};
    authClient.options.headers[headerName] = headerValue;
}
